import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
Vue.use(Vueaxios, axios)
export default {
  PrintsendShiftHost (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  salePosDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleCreditDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleHoldDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleSummary (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  expenseReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/expense', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  expenseIncome (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/income', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  profitReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  dailyReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/send/shift', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  stockReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  movementReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  holdingByCus (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  cancelBill (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  holdingByPaybill (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  holdingByRemain (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/pos/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleType (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleDocType (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleByItem (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  reportSaleCustomer (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  reportHoldbillInvoice (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  StandardReport (URL, header, body, success, error) {
    console.log(body)
    Vue.axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  StandardCostReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_report.js